import React, { Component } from 'react'
import { connect } from 'react-redux'
import renderHTML from 'react-render-html'
import get from 'lodash/get'
import Collapse from '@material-ui/core/Collapse'
import yn from 'yn'

import caretDown from '../../assets/icons/caret-down.svg'

if (yn(process.env.REACT_APP_COMPONENT_ENABLE_LOYALTY_BANNER)) {
  require('../../styles/css/components/loyalty/bk-flow-loyalty-banner.css')
}

class BkFlowLoyaltyBanner extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isExpanded: false
    }
  }

  render() {
    const { isExpanded } = this.state
    const {
      additionalText,
      bannerBackground,
      bannerLogo,
      bannerTexture,
      copy,
      link,
      openLabel,
    } = this.props

    const ctaStyle = {}
    if (bannerBackground) {
      ctaStyle.backgroundImage = `url(${bannerBackground})`
    }
    const contentStyle = {}
    if (bannerTexture) {
      contentStyle.backgroundImage = `url(${bannerTexture})`
    }
    return (
      <div className="bk-flow-loyalty-banner">
        <div className="bk-flow-loyalty-banner__cta" style={ctaStyle}>
          {bannerLogo && <img alt="logo" src={bannerLogo} />}
          <p>{copy}</p>
          {link && (
            <a
              className="btn u-hide-until-desktop-flex"
              href={get(link, 'url')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {get(link, 'text')}
            </a>
          )}
          <button
            className="bk-flow-loyalty-banner__cta__toggle"
            onClick={() => this.setState({ isExpanded: !isExpanded })}
          >
            {isExpanded ? `hide ${openLabel}` : openLabel}
            <div className="loyalty-banner-toggle-btn">
              <img
                alt={isExpanded ? `hide ${openLabel}` : openLabel}
                src={caretDown}
                style={{ transform: `rotate(${isExpanded ? 180 : 0}deg)`}}
              />
            </div>
          </button>
        </div>
        <Collapse
          in={ isExpanded }
          timeout={ 300 }
        >
          <div
            className="bk-flow-loyalty-banner__content__container"
            style={contentStyle}
          >
            {get(additionalText, '[0]') && (
              <h4>{renderHTML(get(additionalText, '[0]'))}</h4>
            )}
            {get(additionalText, '[1]') && (
              renderHTML(get(additionalText, '[1]'))
            )}
            {link && (
              <a
                className="btn u-hide-at-desktop"
                href={get(link, 'url')}
                target="_blank"
                rel="noopener noreferrer"
              >
                {get(link, 'text')}
              </a>
            )}
          </div>
        </Collapse>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  ...get(state, 'hotelContentFeeds.feeds.loyaltyAssets.assets.banner'),
})

const mapDispatchToProps = () => ({})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowLoyaltyBanner)


// WEBPACK FOOTER //
// ./src/components/loyalty/BkFlowLoyaltyBanner.js